import { withInstall } from '@element-plus/utils'
import Affix from './src/affix.vue'
import type { SFCWithInstall } from '@element-plus/utils'

const _Affix = withInstall(Affix)
export const ElAffix: SFCWithInstall<typeof Affix> = _Affix
export default _Affix

export * from './src/affix'
